import { Cancel } from "@mui/icons-material";
import { Button, Dialog } from "@mui/material";
// eslint-disable-next-line @comet/no-private-sibling-import
import { FormButtonsWrapper } from "@src/domain/devices/edit/Form.sc";
import Delete from "@src/icons/Delete";
import { type ReactElement } from "react";
import { FormattedMessage } from "react-intl";

import { ContentWrapper } from "../..";

export interface CommonDeleteDialogProps {
    open: boolean;
    handleClose: () => void;
    title: string | ReactElement;
    dialogBody: ReactElement;
}

interface DeleteDialogProps extends CommonDeleteDialogProps {
    submit: () => void;
}

export const DeleteDialog = ({ title, open, submit, handleClose, dialogBody }: DeleteDialogProps): ReactElement => {
    return (
        <Dialog open={open} onClose={handleClose}>
            <ContentWrapper title={title}>
                {dialogBody}
                <FormButtonsWrapper>
                    <Button startIcon={<Cancel />} variant="text" onClick={handleClose}>
                        <FormattedMessage id="reviermanager.button.cancel" defaultMessage="Abbrechen" />
                    </Button>
                    <Button color="primary" variant="contained" startIcon={<Delete />} onClick={submit}>
                        <FormattedMessage id="reviermanager.button.delete" defaultMessage="Ja, löschen" />
                    </Button>
                </FormButtonsWrapper>
            </ContentWrapper>
        </Dialog>
    );
};
